import ProductCollectionPage from "../common/ProductCollectionPage";

const Shoes = ({ onAddToCart }) => (
  <ProductCollectionPage
    seo={{
      title: "Leather Shoes",
      description: "Hand-finished leather shoes for men in Kenya. Built to last a lifetime — shop Oxford, Derby and loafer styles at Emporia",
      path: "/shoes",
    }}
    query="category=shoes"
    eyebrow="Collection"
    heading="Shoes"
    tagline="Hand-finished leather, built to last a lifetime. Every pair tells a story."
    onAddToCart={onAddToCart}
  />
);

export default Shoes;
